<script>
import ListingModel from "@/views/Request/Claim/Components/ListingModel.vue";
export default {
    name: "AdminRequests",
    components: {ListingModel}
}
</script>

<template>
    <listing-model type="ADMIN_REQUEST"/>
</template>